<template>
  <div class="pad_15 ba_f" style="padding-bottom: 100rpx">
    <div>
      <div class="fon_20 wei">入驻说明</div>
      <div class="color_9 fon_16">
        申请开店过程中需要您提供符合国家法律规定的经营许可证照，包括但不限于营业执照、各类许可证、特许证件等;
      </div>
    </div>
    <div class="pad_l_10 rzsq">
      <el-form ref="uForm" :model="form" :label-width="formLabelWidth" label-position="left">
        <div class="title mar_t15">店铺信息</div>
        <el-form-item required label="商家名称:">
          <el-input v-model="form.name" placeholder="请输入门店名称" prop="name" />
        </el-form-item>
        <el-form-item required label="商家Logo:">
          <el-upload
            :show-file-list="false"
            :on-success="handleAvatarSuccess"
            :before-upload="beforeAvatarUpload"
            :action="upload"
            :data="{uniacid:uniacid}"
            class="avatar-uploader">
            <img v-if="form.icon" :src="form.icon" class="avatar">
            <i v-else class="el-icon-plus avatar-uploader-icon"/>
          </el-upload>
        </el-form-item>
        <el-form-item required label="联系人:">
          <el-input v-model="form.storeLinkMan" placeholder="请输入门店联系人" prop="storeLinkMan" />
        </el-form-item>
        <el-form-item required label="联系电话:">
          <el-input v-model="form.storeTel" type="number" placeholder="请输入门店联系电话" prop="storeTel" />
        </el-form-item>
        <el-form-item required label="所属区域:">
          <div class="flex-bet">
            <div class="flex-g-1" @click="showPicker=true">
              <div
                :style="cityArr?'color:#000':'color:#c0c4cc'"
                style="width:200px;padding-left:15px;color:#c0c4cc"
              >
                <span class="c3 f32" @click="showPicker=true">{{ cityArr||'请选择门店所属区域' }}</span>
              </div>
            </div>
            <div class="flex-g-0 color_9 curs" @click="showPicker=true">
              >
            </div>
          </div>
        </el-form-item>
        <el-form-item required label="详细地址:" prop="address">
          <el-input v-model="form.address" placeholder="请输入详细地址" prop="address" />
          <!--          <div class="flex-bet">-->
          <!--            <div class="flex-g-1" @click="selectAddress">-->
          <!--              <div-->
          <!--                :style="form.address?'color:#000':'color:#c0c4cc'"-->
          <!--                style="width:200px;padding-left:15px;color:#c0c4cc"-->
          <!--                @click="selectAddress"-->
          <!--              >-->
          <!--                <span class="c3 f32">{{ form.address||'请输入门店详细地址' }}</span>-->
          <!--              </div>-->
          <!--            </div>-->
          <!--            <div class="flex-g-0 color_9 curs" @click="selectAddress">-->
          <!--              >-->
          <!--            </div>-->
          <!--          </div>-->
        </el-form-item>
        <!-- <el-form-item label="商家环境:">
          <el-upload
            :on-remove="removeEnvironment"
            :on-success="uploadEnvironment"
            :action="upload"
            :limit="2"
            list-type="picture-card"
            class="upload-list">
            <i class="el-icon-plus"/>
          </el-upload>
        </el-form-item>
        <el-form-item label="食品安全档案:">
          <el-upload
            :file-list="foodRecords"
            :on-remove="handleRemove"
            :action="upload"
            :limit="2"
            list-type="picture-card"
            class="upload-list">
            <i class="el-icon-plus"/>
          </el-upload>
        </el-form-item> -->
        <div class="title mt30">账号信息</div>
        <el-form-item required label="手机号:" prop="phone">
          <el-input v-model="form.phone" type="number" placeholder="请输入绑定手机号" />
        </el-form-item>
        <el-form-item label="登录账号:" required prop="userName">
          <el-input v-model="form.userName" placeholder="请输入登录账号名称" />
        </el-form-item>
        <el-form-item required label="登录密码:">
          <el-input v-model="form.passWord" type="password" placeholder="请输入登录密码" />
        </el-form-item>
        <el-form-item required label="确认登录密码:">
          <el-input v-model="confirmPassword" type="password" placeholder="请确认登录密码" />
        </el-form-item>
        <div class="title mt30">入驻套餐</div>
        <el-form-item label="经营品类:" required>
          <div class="flex-bet">
            <div class="flex-g-1" @click="showOrderType = true">
              <div
                :style="form.orderType.length !== 0?'color:#000':'color:#c0c4cc'"
                style="width:200px;padding-left:15px;color:#c0c4cc"
                @click="showOrderType = true"
              >
                <span class="c3 f32">{{ orderType||'请选择门店经营分类' }}</span>
              </div>
            </div>
            <div class="flex-g-0 color_9 curs" @click="showOrderType = true">
              >
            </div>
          </div>
        </el-form-item>
      </el-form>
    </div>
    <el-button :style="{backgroundColor:color,color:fontColor}" class="btn" @click="saveAddress"> 提交</el-button>
    <Popup v-model="showPicker" :style="{ height: '300px' ,width:'100%'}" position="bottom">
      <Picker :columns="columns" value-key="label" show-toolbar title="请选择区域" @cancel="showPicker=false" @confirm="selectCity"/>
    </Popup>
    <Popup v-model="showOrderType" :style="{ height: '300px' ,width:'100%'}" position="bottom">
      <Picker :columns="category" value-key="name" show-toolbar title="请选择经营分类" @cancel="showOrderType=false" @confirm="selectOrderType"/>
    </Popup>
    <Popup v-model="showMap" :style="{ height: '100%' ,width:'100%'}" position="center">
      <iframe id="mapPage" ref="mapIframe" :src="getMapSrc" width="100%" height="88%" frameborder="0"/>
    </Popup>

  </div>
</template>

<script>
import Popup from 'vant/lib/popup'
import 'vant/lib/popup/style'
import Picker from 'vant/lib/picker'
import 'vant/lib/picker/style'
import { upload } from '@/api/api'
export default {
  name: 'Person',
  components: {
    Popup, Picker
  },
  data() {
    return {
      upload: upload,
      showPicker: false,
      showOrderType: false,
      showMap: false,
      formLabelWidth: '130px',
      form: {
        name: '',
        icon: '',
        storeLinkMan: '',
        storeTel: '',
        cityArr: [],
        address: '',
        environment: [],
        foodRecords: [],

        phone: '',
        userName: '',
        passWord: '',
        lng: '',
        lat: '',

        orderType: []
      },
      cityArr: '',
      orderType: '',
      confirmPassword: '',
      columns: [],
      category: [],
      getMapSrc: '',
      environment: [],
      foodRecords: [],
      query: {
        uniacid: '',
        item: 1
      },
      uniacid: '',
      icon: '',
      color: '',
      fontColor: ''

    }
  },
  created() {
    // console.log(this.$route.query.uniacid)
    this.form.uniacid = this.$route.query.uniacid
    this.getMapSrc = 'https://mapapi.qq.com/web/mapComponents/locationPicker/v/index.html?search=1&type=1&key=EOJBZ-HSBW6-G2VSM-EE3KV-4OAAK-RXFWT&referer=ybcyapp&coord='
    document.title = this.$route.name
    if (this.$route.query.uniacid) {
      this.uniacid = this.$route.query.uniacid
      this.form.uniacid = this.$route.query.uniacid
      this.query.uniacid = this.$route.query.uniacid
      this.init()
      this.getConfigM2()
      this.getConfigM3()
    }
  },
  methods: {
    handleRemove(a, b, c) {
      // console.log(this.environment)
      // console.log(a, b, c)
    },
    init() {
      this.$api.getCity({ type: 3, uniacid: this.uniacid }).then(res => {
        this.columns = res.data
      })
      this.$api.getCategory(this.query).then(res => {
        if (res.data.length) {
          for (let i = 0; i < res.data.length; i++) {
            res.data[i].children.unshift({
              name: '全部分类',
              pid: '',
              id: ''
            })
          }
          this.category = res.data
        }
      })
      if (this.$route.query.uniacid) {
        this.form.uniacid = this.$route.query.uniacid
        this.query.uniacid = this.$route.query.uniacid
      }
    },
    getConfigM2() {
      this.$api.getConfig({ ident: 'style', uniacid: this.uniacid }).then(res => {
        this.color = res.data.color
        this.fontColor = res.data.fontColor
      })
    },
    getConfigM3() {
      this.$api.getConfig({ ident: 'customName', uniacid: this.uniacid }).then(res => {
        document.title = res.data.storeIn ? res.data.storeIn : '商家入驻'
      })
    },
    selectCity(e, i) {
      this.cityArr = e.join(' ')
      this.form.cityArr[0] = this.columns[i[0]].value
      this.form.cityArr[1] = this.columns[i[0]].children[i[1]].value
      this.form.cityArr[2] = this.columns[i[0]].children[i[1]].children[i[2]].value

      this.showPicker = false
    },
    selectOrderType(e, i) {
      this.form.orderType = []
      this.orderType = e.join('/')
      // 确定i分类层级只有两层
      this.form.orderType.push(this.category[i[0]].id)
      if (this.category[i[0]].children[i[1]].id) {
        this.form.orderType.push(this.category[i[0]].children[i[1]].id)
      }
      this.showOrderType = false
      // console.log(123,this.form.orderType,this.category[i[0]].children[i[1]].id)
    },
    selectAddress() {
      this.showMap = true
      const that = this;
      (function() {
        window.addEventListener('message', function(event) {
        // 接收位置信息，用户选择确认位置点后选点组件会触发该事件，回传用户的位置信息
          that.showMap = false
          that.form.lat = event.data.latlng.lat
          that.form.lng = event.data.latlng.lng
          that.form.address = event.data.poiaddress

          // var loc = event.data
          // if (loc && loc.module == 'locationPicker') { // 防止其他应用也会向该页面post信息，需判断module是否为'locationPicker'
          //   that.chooselocation = loc
          // // showDialog(JSON.stringify(loc),'位置信息')
          // }
        }, false)
      }())
    },
    handleAvatarSuccess(res, file) {
      this.form.icon = res.data
    },
    beforeAvatarUpload(file) {
      const isJPG = file.type === 'image/jpeg'
      const isPng = file.type === 'image/png'
      const isLt6M = file.size / 1024 / 1024 < 6

      if (!isJPG && !isPng) {
        this.$message.error('上传LOGO图片只能是 JPG或PNG 格式!')
      }
      if (!isLt6M) {
        this.$message.error('上传头像图片大小不能超过 6MB!')
      }
      return (isJPG || isPng) && isLt6M
    },
    saveAddress() {
      this.$refs['uForm'].validate(async(valid) => {
        if (valid) {
          if (this.confirmPassword !== this.form.passWord) {
            this.$message({
              type: 'error',
              message: `密码不一致: 请确认两次密码一致`
            })
            return
          }
          this.$api.saveStore(this.form).then(res => {
            this.$message({
              type: 'success',
              message: `${res.msg}: 信息提交成功，请等待管理员审核！`
            })
            if (res.code == '1') {
              this.form = {
                name: '',
                icon: '',
                storeLinkMan: '',
                storeTel: '',
                cityArr: [],
                address: '',
                environment: [],
                foodRecords: [],

                phone: '',
                userName: '',
                passWord: '',
                lng: '',
                lat: '',

                orderType: []
              }
              this.form.cityArr = ''
              this.orderType = ''
              this.confirmPassword = ''
            }
            this.init()
          })
        } else {
          return false
        }
      })
    }
  }
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .title {
    position: relative;
    font-size: 18px;
    font-weight: bold;
    padding-left: 10px;
    margin-left: -10px;
  }

  .title::after {
    content: "";
    position: absolute;
    left: 0;
    top: 50%;
    transform: translateY(-50%);
    width: 3px;
    height: 16px;
    background: #ffd24d;
  }

  .btn {
    width: 100%;
    font-size: 14px;
    border-radius: 5px;
    background-color: #ffd24d;
    border-color: #ffd24d;
    border: none;
  }
  .avatar {
    width: 75px;
    height: 75px;
    display: block;
  }
  .avatar-uploader  {
    width: 75px;
    height: 75px;
    margin-bottom: 20px;
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
   .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 75px;
    height: 75px;
    line-height: 75px;
    text-align: center;
  }
  .upload-list>>>.el-upload--picture-card{
    width: 60px;
    height: 60px;
    line-height: 70px;
    margin-bottom: 20px;
  }
  .upload-list >>>ul li{
    width: 60px;
    height: 60px;
    line-height: 70px;
  }

  .rzsq >>> .el-form-item__label {
    font-size: 16px;
  }
  .rzsq >>> .el-input {
    font-size: 16px;
  }
  .rzsq >>> .el-form-item__content {
    font-size: 16px;
  }

</style>



// WEBPACK FOOTER //
// src/pages/apply-for-joining.vue